import request from '@/utils/request'

/**
 * 公告管理API接口
 */

// 获取当前启用的公告
export function getCurrentAnnouncement() {
  return request({
    url: '/api/announcement/current',
    method: 'get'
  })
}

// 管理员获取公告列表
export function getAnnouncementList(params) {
  return request({
    url: '/api/announcement',
    method: 'get',
    params
  })
}

// 管理员根据ID获取公告详情
export function getAnnouncementById(id) {
  return request({
    url: `/api/announcement/${id}`,
    method: 'get'
  })
}

// 管理员创建公告
export function createAnnouncement(data) {
  return request({
    url: '/api/announcement',
    method: 'post',
    data
  })
}

// 管理员更新公告
export function updateAnnouncement(id, data) {
  return request({
    url: `/api/announcement/${id}`,
    method: 'put',
    data
  })
}

// 管理员删除公告
export function deleteAnnouncement(id) {
  return request({
    url: `/api/announcement/${id}`,
    method: 'delete'
  })
}